import { validationTranslationKeys } from '@va/constants';
import { validateDomain } from '@va/util/helpers';
import { object, string } from 'yup';

export const getCustomDomainValidationSchema = (t: (s: string) => string) => {
  return object({
    customDomain: string()
      .required(t(validationTranslationKeys.required))
      .test({
        name: 'punycode',
        message: t(validationTranslationKeys.invalidDomain),
        test: (value) => {
          // required rule is handled using the .required() method
          if (!value) return true;

          return validateDomain(value);
        },
      }),
  });
};
